import http from 'hub-http/clients/apiClient';
const URL = 'designmanager/v1/templates/paginated-usable-templates';
const QUERY_PARAMS = {
  categoryId: 8,
  includeHidden: true,
  includeUserMeta: true,
  offset: 0,
  limit: 100,
  templateType: 44
};
export const fetchTemplates = () => {
  return http.get(URL, {
    query: QUERY_PARAMS
  });
};